import React from "react";
import { DailyTip } from "@/features/daily/components/DailyTip";
import type { TodayFunnelVm } from "@/features/daily/components/command/today-view-model";

/**
 * D134 + D136: today from creation to completion, one compact funnel per type side by
 * side — orders and deposits are never averaged together. Each step reads as a share of
 * that type's created operations.
 */
export const TodayFunnelCard: React.FC<{ vm: TodayFunnelVm }> = ({ vm }) => (
    <section className="daily-panel daily-today-card daily-today-funnel" aria-labelledby="daily-today-funnel-title">
        <div className="daily-panel__head">
            <h2 id="daily-today-funnel-title">Embudo de las creadas hoy</h2>
        </div>
        <div className="daily-today-funnel__types">
            {vm.map((funnel) => (
                <section key={funnel.key} className="daily-today-funnel__type" data-type={funnel.key} aria-label={`Embudo de las creadas hoy · ${funnel.title}`}>
                    <div className="daily-today-funnel__head">
                        <h3>{funnel.title}</h3>
                        <span className="daily-today-funnel__conversion">
                            {funnel.headlineLabel} <strong>{funnel.headlineValue}</strong>
                            <DailyTip id={`daily-today-funnel-tip-${funnel.key}`} label={`Qué mide el embudo de ${funnel.title.toLowerCase()}`} lines={funnel.tooltip} />
                        </span>
                    </div>
                    <ol className="daily-today-funnel__steps">
                        {funnel.steps.map((step) => (
                            <li key={step.key} className="daily-today-funnel__step" data-step={step.key}>
                                <span className="daily-today-funnel__label">{step.label}</span>
                                <span className="daily-today-funnel__bar" aria-hidden="true">
                                    <span style={{ width: `${Math.round((step.share ?? 0) * 100)}%` }} />
                                </span>
                                <span className="daily-today-funnel__count">{step.countLabel}</span>
                                <span className="daily-today-funnel__share">{step.shareLabel}</span>
                            </li>
                        ))}
                    </ol>
                    {funnel.createdBeforeNote === null ? null : (
                        <p className="daily-small daily-muted daily-today-funnel__before">{funnel.createdBeforeNote}</p>
                    )}
                </section>
            ))}
        </div>
    </section>
);
